export const customerInfoFields = [
  { label: "ID", key: "row_id.value" },
  {
    label: "Nama Pelanggan", key: "name.value", isSortable: true,
  },
  {
    label: "Email", key: "email.value", isSortable: true,
  },
  {
    label: "Karyawan Permasaran", key: "marketing_user_name.value", isSortable: true,
  },
  {
    label: "NPWP", key: "npwp.value", isSortable: true,
  },
  {
    label: "Kategori Industri", key: "industry_category_name.value", isSortable: true,
  }
].map((field) => ({
  ...field,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:180px;',
  },
}));

export const contactFields = [
  { label: "ID", key: "row_id.value" },
  {
    label: "Nama", key: "name.value", isSortable: true,
  },
  {
    label: "Nomor Telepon", key: "phone.value", isSortable: true,
  },
  {
    label: "Posisi", key: "position.value", isSortable: true,
  },
  {
    label: "Email", key: "email.value", isSortable: true,
  },
].map((field) => ({
  ...field,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:180px;',
  },
}));

export const deliveryNotesFields = [
  { label: "ID", key: "row_id.value" },
  {
    label: "Catatan Pengiriman", key: "note.value",
    isSortable: true,
  },
].map((field) => ({
  ...field,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:180px;',
  },
}));
